AuthRoute = require 'mixins/authenticated-route'

App.SettingsStaffShowRoute = Em.Route.extend AuthRoute,
  session: Em.inject.service()
  model: (params) ->
    model_name = 'staff_member'
    if @get('session.currentUser.isLogisticsStaff')
      model_name = 'logistics_staff'

    new Em.RSVP.Promise (resolve, reject) =>

      @store.fetchById(model_name, params.id)
      .then (staff) =>
        staff.get('restaurants')
        .catch =>
          resolve(staff)
        .then (restaurants) =>
          resolve(staff)
      , reject

  controllerName: 'settingsStaffEdit'
  templateName:   'settings.staff.edit'

  actions:
    willTransition: ->
      controller = @get('controller')
      controller.teardown()

      staff = controller.get('model')
      # Не понятно зачем это было нужно,
      # оно портило часть атрибутов модели текущего юзера, если открыть карточку "себя"
      # @store.unloadRecord( staff )
